export const GET_TREATMENT_LISTING_CONST = 'GET_TREATMENT_LISTING_CONST'


export const CLEAR_TREATEMENT_LIST = 'CLEAR_TREATEMENT_LIST' 